module.exports = __webpack_public_path__ + "static/dashboard-d71c73571a642b33c8dd9261e0a9c123.svg";